<template>
	<div class="hellowd_channel_content">
	<section>		
		<el-container  style="height:550px;background-color:#f6f6f6;">
		  <el-aside width="200px" style="background-color:#fff;">
			<el-menu :default-openeds="['1', '3']">					
					<el-menu-item index="2">
						<i class="fa fa-sliders"></i>
						<span slot="title" class="isactive dslabel">选择渠道</span>
					  </el-menu-item>
					  <el-menu-item index="3" disabled>
						<i class="el-icon-aa"></i>
						<span slot="title" class="dslabel">广告组</span>
					  </el-menu-item>
					  <el-menu-item index="3" disabled>
						<i class="el-icon-aa"></i>
						<span slot="title">推广目的</span>
					  </el-menu-item>
					  <el-menu-item index="3" disabled>
						<i class="fa fa-tags"></i>
						<span slot="title" class="dslabel">广告计划</span>
					  </el-menu-item>
					  <el-menu-item index="3" disabled>
						<i class="el-icon-aa"></i>
						<span slot="title">用户定向</span>
					  </el-menu-item>
					  <el-menu-item index="3" disabled>
						<i class="el-icon-aa"></i>
						<span slot="title">设置预算</span>
					  </el-menu-item>
					  <el-menu-item index="3" disabled>
						<i class="el-icon-aa"></i>
						<span slot="title">计划名称</span>
					  </el-menu-item>
					  <el-menu-item index="4" disabled>
						<i class="el-icon-setting"></i>
						<span slot="title" class="dslabel">广告创意</span>
					  </el-menu-item>
                       <el-menu-item index="3" disabled>
						<i class="el-icon-aa"></i>
						<span slot="title">制作创意</span>
					  </el-menu-item>
                      <el-menu-item index="3" disabled>
						<i class="el-icon-aa"></i>
						<span slot="title">投放位置</span>
					  </el-menu-item>
                      <el-menu-item index="3" disabled>
						<i class="el-icon-aa"></i>
						<span slot="title">创意分类</span>
					  </el-menu-item>
                      <el-menu-item index="3" disabled>
						<i class="el-icon-aa"></i>
						<span slot="title">创意名称</span>
					  </el-menu-item>					  
			</el-menu>
		  </el-aside>
  <el-container>  
		<el-main>
		    <el-page-header @back="goBack" content="选择渠道"></el-page-header>
			<el-row class="channel_list" :gutter="20">			 
			      <el-col :span="6"><div class="grid-content c1 channel_active"></div></el-col>
				  <el-col :span="6"><div class="grid-content c2"></div></el-col>
				  <el-col :span="6"><div class="grid-content c3"></div></el-col>
				  <el-col :span="6"><div class="grid-content other">更多其他渠道 >> </div></el-col>		 
			</el-row>
			<el-row>
			  <el-col :span="24">
			  <div class="hellowd_ca_btn">
			   <router-link to="/promotion/110659871557">立即前往 <i class="fa fa-long-arrow-right"></i></router-link>
			  </div>
			  </el-col>
			</el-row>
		</el-main>
  </el-container>
</el-container>
	</section>
	</div>
</template>

<script>
	
	export default {
		data() {
			return {
				keyword: '',
				levellist:[]		
			}
		},
		methods: {
		  goBack(){
		    this.$router.go(-1);
		  }
		},
		mounted() {
					
		}
	}

</script>
<style  lang="scss">
   .hellowd_channel_content{background-color:#fff;}
   .hellowd_channel_content .isactive{color:#red;}  
   .hellowd_channel_content .dslabel{font-size:14px;font-weight:700;}
    .hellowd_channel_content .el-menu{background-color:#fff;}
    .hellowd_channel_content .hellowd_ca_btn{text-align:center;margin-top:10%;}	
	.hellowd_ca_btn a{
	    margin: 0 50px;
		padding: 0 20px;
		width: 265px;
		height: 50px;
		line-height: 50px;
		font-size: 18px;
		color: #2f88ff;
		border-radius: 30px;
		border:1px solid #2f88ff;
		background-color:#fff;
		display: inline-block;
		text-decoration:none;
		cursor:pointer;
	}
	.hellowd_ca_btn a:hover{
	  background:#2f88ff;
	  color:#fff;
	}
   .hellowd_channel_content .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  .hellowd_channel_content .el-aside {
    color: #333;
  }
  .hellowd_channel_content .c1{background:#ddd url('../../assets/toutiao.png') no-repeat center center;background-size:50% 90%;}
  .hellowd_channel_content .c2{background:#ddd url('../../assets/facebook.png') no-repeat center center;background-size:99% 99%;}
  .hellowd_channel_content .c3{background:#fff url('../../assets/adwords.png') no-repeat center center;background-size:70% 90%;}
  .hellowd_channel_content .c4{background:#fff url('../../assets/tiktok.png') no-repeat center center;background-size:90% 30%;}
  .hellowd_channel_content .other{background-color:#1a3e59;font-size:16px;color:#fff;opacity:0.6;}
  .hellowd_channel_content .channel_list{color:#222;padding:20px;margin:20px 0px;}
  .hellowd_channel_content .grid-content{height: 120px;border: 1px solid #EDF1F5;
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.05);
    border-radius: 4px;
    cursor: pointer;
	line-height:120px;
	text-align:center;
}
.hellowd_channel_content .grid-content:hover,.grid-content .channel_active{border:2px solid red;}
</style>


// WEBPACK FOOTER //
// channel.vue?7c2fc70e